import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormRequest, ListOption, FormSaveResponse } from '../../../../modules/tcm-core.module';
import { permissionAreaKeyNameOf, permissionEnityKeyNameOf } from '../../../../helpers/permission.helpers';
import { AdminArea } from '../../../../models/roles';
import { CurrentUserSettingsFormResponse } from '../../../../models/users';
import { TcmBaseDetails } from '../../../../modules/tcm-common/base/tcm-base-details';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { ListOptionService } from '../../../../services/list-option.service';
import { LoginApiService } from '../../../../services/system/login-api.service';
import { SetupTranslationSystemService } from '../../../../services/system/setup-translation-system.service';
import { SchedulerDefaultViewEnum } from 'src/app/models/enums/scheduler-default-view-enum';

@Component({
    selector: 'user-settings-details',
    templateUrl: './user-settings-details.component.html',
    standalone: false
})
export class UserSettingsDetailsComponent extends TcmBaseDetails<FormRequest, CurrentUserSettingsFormResponse>{

  public defaultPageOptions: ListOption<number>[];
  public schedulerDefaultViewOptions: ListOption<number>[];
  public canEditTranslations: boolean = false;
  public canEdit : boolean = true;

  constructor(protected override componentContext: SecureBaseComponentContext,
    protected override route: ActivatedRoute,
    private listOptionService: ListOptionService,
    private readonly loginService: LoginApiService,
    private setupTranslationSystemService: SetupTranslationSystemService) {

    super(componentContext, route);
    this.actionName = 'CurrentUserSettings/Details';
    this.defaultPageOptions = this.listOptionService.getDefaultPageOptions();
    
    this.schedulerDefaultViewOptions = this.listOptionService.getSchedulerDefaultViewOptions();
    
    const schedulerViewOrder = [ 
      SchedulerDefaultViewEnum.Day, 
      SchedulerDefaultViewEnum.WorkWeek, 
      SchedulerDefaultViewEnum.Week, 
      SchedulerDefaultViewEnum.Month, 
      SchedulerDefaultViewEnum.Flow, 
      SchedulerDefaultViewEnum.Timeline ];

    this.schedulerDefaultViewOptions.sort(function(a,b) { 
      return (schedulerViewOrder.indexOf(a.value)) - (schedulerViewOrder.indexOf(b.value));
    });

    this.componentContext.permissionService
    .getEntityPermissions$(permissionAreaKeyNameOf('admin'), permissionEnityKeyNameOf<AdminArea>('translations'))
    .subscribe(x => {
      this.canEditTranslations = x && x.canEdit === true;
    });
  }

  protected override async processSaveAsync(options?: any): Promise<FormSaveResponse> {

      const result =  await super.processSaveAsync(options);
      await this.loginService.refreshTokenAsync();
      await this.changeTranslationMode();

      return result;

  }

  public async changeTranslationMode() {

    if (this.viewModel.form.isTranslationMode) {
      this.setupTranslationSystemService.setTranslationMode(this.viewModel.form.translationId.toString());
    } else {
      await this.setupTranslationSystemService.resetTranslationMode(this.viewModel.form.translationId.toString());
    }
    this.setupTranslationSystemService.setTranslationModeValue(this.viewModel.form.isTranslationMode);
   }

   protected override onProcessSaveSuccess() {
    this.ngForm?.form.markAsPristine();

  }
}
